import { trackAIEvent } from "~/EasyProjects/AppInsights/AppInsightsHelper";
import { trackAmplitudeEvent } from "~/sharedComponents/amplitude/trackAmplitudeEvent";
import { trackFSEvent } from "~/sharedComponents/fullStory/utils/trackFSEvent";
import { trackUserFlowEvent } from "~/sharedComponents/userflow/utils/trackUserFlowEvent";
import { devMode } from "../devMode";

type EventPayload = {
    /** Used only for very initial FC event: if true, event will be dispatched to fullstory but only after fullstory is initialized and ready */
    trackFullStorySafely?: boolean;
    [key: string]: any;
};

export const trackEvent = (eventName: string, data: EventPayload = {}) => {
    if (eventName) {
        if (eventsDebug.isEnabled()) {
            // eslint-disable-next-line no-console
            console.log(`trackEvent: '${eventName}'`, { ...data });
        }

        const { trackFullStorySafely, ...payload } = data;

        // eslint-disable-next-line no-restricted-syntax
        trackAIEvent(eventName, payload);
        // eslint-disable-next-line no-restricted-syntax
        trackFSEvent(eventName, trackFullStorySafely);
        // eslint-disable-next-line no-restricted-syntax
        trackUserFlowEvent(eventName);
        // eslint-disable-next-line no-restricted-syntax
        trackAmplitudeEvent(eventName, payload);
    }
};

// expose trackEvent to CSV/MsProject import iframe
window.trackEvent = trackEvent;
declare global {
    interface Window {
        trackEvent: typeof trackEvent;
    }
}

/**
 * To log tracked events into console run `ep.debug_audit_events(true);` in console.
 * To disable logging run `ep.debug_audit_events(false);`
 */
const DEBUG_KEY = "ep_debug_audit_events";
export const eventsDebug = new devMode(DEBUG_KEY);
ep.debug_audit_events = (value: boolean) => eventsDebug.setIsEnabled(value);
